import { useTranslation } from '@root/shared/localization'
import { InfoMessage } from '@root/shared/ui-kit'

import { AnalysisCommon } from './analysis-common'

type Props = {
  onRetry: () => void
}

export const AnalysisError = (props: Props) => {
  const { t } = useTranslation()
  return (
    <AnalysisCommon value={undefined}>
      <InfoMessage
        intent="error"
        title={t('common.error')}
        onRetry={props.onRetry}
        description={t('common.something_went_wrong_try_again')}
      />
    </AnalysisCommon>
  )
}
